import { render, staticRenderFns } from "./Donate.vue?vue&type=template&id=3ca77be3&scoped=true&"
var script = {}
import style0 from "./Donate.vue?vue&type=style&index=0&id=3ca77be3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca77be3",
  null
  
)

export default component.exports